import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IInstitutionUnit,
  IUnit,
  IUnitConfiguration,
  UnitType,
} from 'src/app/models';

@Injectable({ providedIn: 'root' })
export class UnitsService {
  private http = inject(HttpClient);
  private _baseUrl = '/api/units';

  getUnitsForInstitution(instId: number): Observable<IUnit[]> {
    return this.http.get<IUnit[]>(`${this._baseUrl}/${instId}`);
  }

  getUnitsFromManyInstitutions(
    institutionIds: number[],
    restrictToUnitTypeIds: number[] | UnitType[],
  ): Observable<IInstitutionUnit[]> {
    return this.http.post<IInstitutionUnit[]>(
      `${this._baseUrl}/GetInstitutionUnitsForInstitutions`,
      { institutionIds, restrictToUnitTypeIds },
    );
  }

  getConfigurationsForUnit(
    unitId: number,
    institutionId: number,
  ): Observable<IUnitConfiguration[]> {
    return this.http.post<IUnitConfiguration[]>(
      `${this._baseUrl}/GetConfigurations`,
      { unitId, institutionId },
    );
  }
}
